// @flow
import { handleResponseOld, makeGet, makePost } from './helpers';

type FetchNotificationsParams = {
    authToken: string,
    deployment: string,
};

type PostDisableWebPushSubscriptionParams = {
    authToken: string,
    deployment: string,
};

type PostMarkDeletedParams = {
    authToken: string,
    deployment: string,
    notificationIds: any,
};

type PostMarkReadParams = {
    authToken: string,
    deployment: string,
    notificationIds: any,
};

type PostUpdateWebPushSubscriptionParams = {
    authToken: string,
    deployment: string,
    subscription: any,
};

export default {
    fetchNotifications: ({ authToken, deployment }: FetchNotificationsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({ authToken, deployment, path: '<NOTIFICATIONS-API>getNotifications' });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    postDisableWebPushSubscription: ({ authToken, deployment }: PostDisableWebPushSubscriptionParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ authToken, deployment, path: '<NOTIFICATIONS-API>disableWebPushSubscription' });
            request.send();
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    postMarkDeleted: ({ authToken, deployment, notificationIds }: PostMarkDeletedParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ authToken, deployment, path: '<NOTIFICATIONS-API>markNotificationsDeleted' });
            request.send({ ids: notificationIds });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    postMarkRead: ({ authToken, deployment, notificationIds }: PostMarkReadParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ authToken, deployment, path: '<NOTIFICATIONS-API>markNotificationsRead' });
            request.send({ ids: notificationIds });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    postUpdateWebPushSubscription: ({ authToken, deployment, subscription }: PostUpdateWebPushSubscriptionParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ authToken, deployment, path: '<NOTIFICATIONS-API>updateWebPushSubscription' });
            request.send(subscription);
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
